import { useEffect } from "react";

import colors from "@moodys/mdc-frontend.theming.colors";
import { EventBusTopic } from "@moodys/mdc-frontend.utils.event-bus";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import { useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";

import { config } from "config";
import { useAvoTracking } from "hooks/useAvoTracking";
import { useEventBus } from "hooks/useEventBus";

import { accessibeTriggerContainerStyles as styles } from "./AccessibeTriggerContainer.styles";

export const OPEN_ACCESSIBE_TEXT =
  "Open accessiBe: accessibility options, statement and help";

export const removeAccessibeTriggerContainer = () => {
  document.getElementById(config.ACCESSIBE_ELEMENT_ID)?.remove();
};

export const initializeAccessibe = () => {
  try {
    // @ts-expect-error
    acsbJS.init({
      hideMobile: true,
      hideTrigger: true,
      language: "en",
      leadColor: colors.globalBlue700,
      position: "right",
      triggerPositionX: "right",
      triggerPositionY: "top",
    });
  } catch {
    removeAccessibeTriggerContainer();
  }
};

export const AccessibeTriggerContainer = () => {
  const [searchOpen] = useEventBus(EventBusTopic.SearchbarOpen);
  const [isAuthenticated] = useEventBus(EventBusTopic.IsAuthenticated);
  const theme = useTheme();
  const { trackAccessibeClick } = useAvoTracking();

  useEffect(() => {
    const script = document.createElement("script");
    script.defer = true;
    script.onerror = removeAccessibeTriggerContainer;
    script.onload = initializeAccessibe;
    script.src = config.ACCESSIBE_SRC;
    document.body.append(script);
  }, []);

  return (
    <div
      css={styles.accessibeTriggerContainer(searchOpen, isAuthenticated)}
      data-testid={config.ACCESSIBE_ELEMENT_ID}
      id={config.ACCESSIBE_ELEMENT_ID}
    >
      <IconButton
        aria-label={OPEN_ACCESSIBE_TEXT}
        color="primary"
        size="small"
        css={styles.accessibeTrigger(theme)}
        data-acsb-custom-trigger="true"
        onClick={() => trackAccessibeClick()}
      >
        <AccessibilityNewIcon />
      </IconButton>
    </div>
  );
};
